/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import keysToConstants from 'js/lib/keysToConstants';

import { Button, Popover, Typography2 } from '@coursera/cds-core';
import { CheckIcon, ContextualHelpIcon, ErrorIcon, WarningFilledIcon } from '@coursera/cds-icons';

export const RESULT_TYPES = keysToConstants(['SUCCESS', 'WARNING', 'ERROR', 'INFO']);

const { SUCCESS, WARNING, ERROR, INFO } = RESULT_TYPES;

type ResultsObject = {
  id: string;
  type: keyof typeof RESULT_TYPES;
  label: string;
  count?: React.ReactNode;
  details?: string;
};

type Props = {
  results: Array<ResultsObject>;
};

const styles = {
  wrapper: () => css`
    border: 1px solid var(--cds-color-neutral-stroke-primary);
  `,
  item: css`
    width: 50%;
  `,
};

const MutationResultDetails = ({ results }: Props) => {
  const [popoverAnchor, setPopoverAnchor] = React.useState<HTMLButtonElement | null>(null);

  return (
    <div css={styles.wrapper} className="rc-MutationResultDetails horizontal-box p-t-1 wrap">
      {results.map(({ type, label, count, details }) => (
        <div
          key={label}
          css={styles.item}
          className="c-resultsItem horizontal-box align-items-spacebetween align-items-vertical-center p-b-1 p-l-1 p-r-1"
        >
          <div className="horizontal-box align-items-vertical-center">
            {type === INFO && <ContextualHelpIcon />}
            {type === SUCCESS && <CheckIcon />}
            {type === WARNING && <WarningFilledIcon color="warning" />}
            {type === ERROR && <ErrorIcon color="error" />}
            {details ? (
              <React.Fragment>
                <Button
                  variant="ghost"
                  size="small"
                  onClick={(e) => setPopoverAnchor(e.currentTarget)}
                  css={css`
                    padding: 0;
                    margin-left: var(--cds-spacing-200);
                  `}
                >
                  {label}
                </Button>
                <Popover
                  open={Boolean(popoverAnchor)}
                  anchorElement={popoverAnchor}
                  onClose={() => setPopoverAnchor(null)}
                >
                  <Popover.Body component="div" tabIndex={0}>
                    <Typography2 component="p">{details}</Typography2>
                  </Popover.Body>
                </Popover>
              </React.Fragment>
            ) : (
              <p className="m-l-1 m-b-0">{label}</p>
            )}
          </div>
          <p className="m-r-2 m-b-0" data-e2e="mutation-count">
            {count}
          </p>
        </div>
      ))}
    </div>
  );
};
export default MutationResultDetails;
